export var StatusButtonVariant;
(function (StatusButtonVariant) {
    StatusButtonVariant["OUTLINE"] = "outline";
    StatusButtonVariant["SIMPLE"] = "simple";
})(StatusButtonVariant || (StatusButtonVariant = {}));
